var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArchiveIcon = function SvgArchiveIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D14339",
    d: "M23.29 5H4.677a.527.527 0 0 0-.527.527v2.458c0 .291.236.527.527.527H23.29a.527.527 0 0 0 .526-.527V5.527A.527.527 0 0 0 23.29 5M5.555 9.914v12.292a1.054 1.054 0 0 0 1.053 1.053h14.75a1.053 1.053 0 0 0 1.054-1.053V9.914zm8.428 10.124-3.805-3.803.996-.995 2.107 2.11V12.02h1.405v5.328l2.11-2.11.992.994z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArchiveIcon);
export default ForwardRef;